var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikehover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.874,
    height: 92.875,
    viewBox: "0 0 92.874 92.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_102",
    x: 0,
    y: 0,
    width: 92.874,
    height: 92.875,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_10_50",
    "data-name": "Component 10 \\u2013 50",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102-2",
    "data-name": "Path 102",
    d: "M76.374,38.937A37.437,37.437,0,1,1,38.937,1.5,37.437,37.437,0,0,1,76.374,38.937",
    transform: "translate(7.5 4.5)",
    fill: "#099"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(14.545 10.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M34.3,45.945c1.519.247,3.015.416,4.476.747a53.72,53.72,0,0,1,5.381,1.466,19.544,19.544,0,0,0,5.876,1.017c2.524.056,5.053-.078,7.579-.08a4.435,4.435,0,0,0,4.4-4.606,2.279,2.279,0,0,1,.491-1.951c.325-.327.717-.6,1.008-.948a5.263,5.263,0,0,0,1.058-4.668,2.425,2.425,0,0,1,.619-2.272,5.245,5.245,0,0,0,1.061-5.87,1.489,1.489,0,0,1,.19-1.685,4.863,4.863,0,0,0,1.026-3.874,3.264,3.264,0,0,0-2.98-2.745c-2.069-.117-4.146-.085-6.219-.143-1.9-.053-3.8-.136-5.706-.217a3.469,3.469,0,0,1-.721-.13c-1.212-.318-1.64-1.013-1.173-2.2.531-1.345,1.193-2.64,1.817-3.948a18.748,18.748,0,0,0,1.876-5.655,8.361,8.361,0,0,0-1.5-6.536A5.4,5.4,0,0,0,51.387.36a1.823,1.823,0,0,0-2.923,1.224c-.266,1.055-.4,2.143-.59,3.218A22.548,22.548,0,0,1,46.1,11.077a6.506,6.506,0,0,1-2.168,2.317,18.353,18.353,0,0,0-4.352,5.153q-2.059,3.177-4.107,6.36a.715.715,0,0,1-.136.18,3.335,3.335,0,0,0-1.082,3c.048,5.812.021,11.625.022,17.438,0,.147.015.293.022.416",
    transform: "translate(-19.85 0)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M6.047,49.282H.813c-.709,0-.812.1-.812.785Q0,60.631,0,71.194c0,.761.117.873.9.873H11.264c.688,0,.85-.154.845-.837-.012-1.756-.049-3.513-.047-5.27q.012-7.649.047-15.3c0-.2,0-.4,0-.593-.011-.649-.139-.783-.78-.784q-2.642,0-5.283,0Z",
    transform: "translate(0 -24.582)",
    fill: "#fbfbfb"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikehover);
export default __webpack_public_path__ + "static/media/likehover.f4a13d1d4fd18098987c7a40a04c0d1b.svg";
export { ForwardRef as ReactComponent };